import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Collapsible from './Collapsible';
// eslint-disable-next-line import/no-cycle
import ViewObject from './ViewObject';
import objectSummary from '../utils/objectSummary';
import {
	getSettings,
	watchSettings,
	unwatchSettings
} from '../utils/eventViewerSettings';
import './KeyValue.scss';

export default function KeyValue({
	dataKey,
	dataValue,
	keyClasses = '',
	valueClasses = '',
	className = ''
}) {
	const [defaultOpened, setDefaultOpened] = useState(
		getSettings().eventObjectsOpenedByDefault
	);
	useEffect(() => {
		const settingsChangeHandler = (settings) =>
			setDefaultOpened(settings.eventObjectsOpenedByDefault);
		watchSettings(settingsChangeHandler);
		return function cleanup() {
			unwatchSettings(settingsChangeHandler);
		};
	});

	if (dataValue !== null && typeof dataValue === 'object') {
		return (
			<Collapsible
				title={dataKey}
				summary={objectSummary(dataValue)}
				className={`py-1 ${className}`}
				defaultOpened={defaultOpened}
			>
				<ViewObject object={dataValue} />
			</Collapsible>
		);
	} else {
		const useValue = dataValue === null ? <pre>null</pre> : dataValue;
		return (
			<div className={className}>
				<div
					className={[
						'KeyValue-key',
						'd-inline-block',
						'border-right',
						'p-2',
						'overflow-hidden',
						'align-top',
						keyClasses
					].join(' ')}
				>
					{dataKey}
				</div>
				<div
					className={[
						'KeyValue-value',
						'd-inline-block',
						'p-2',
						'overflow-auto',
						'align-top',
						valueClasses
					].join(' ')}
				>
					{useValue}
				</div>
			</div>
		);
	}
}

KeyValue.propTypes = {
	dataKey: PropTypes.string.isRequired,
	dataValue: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
		PropTypes.shape({})
	]),
	keyClasses: PropTypes.string,
	valueClasses: PropTypes.string,
	className: PropTypes.string
};
